import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import CalendarFilled from '@icon/CalendarFilled';
import dateHelper, { getDateShort } from '@utils/dates';
import { Spacings, breakpoints } from '@styles/index';

const Flex = styled.div`
  display: flex;
  align-items: center;
  grid-column: span 5;
  margin-top: ${Spacings.SPACING_8B};
  margin-right: ${(props) =>
    props.$fromAboutDrawer ? '0' : Spacings.SPACING_10B};
  @media (max-width: 47.95em) {
    margin-top: 24px;
    grid-column: span 10;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  height: ${Spacings.SPACING_12B};
  width: ${Spacings.SPACING_12B};
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--color-divider);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 40px;
    height: 40px;
  }
`;

const Info = styled.div`
  margin-left: ${Spacings.SPACING_4B};
  align-self: center;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-left: ${Spacings.SPACING_3B};
    & > h6 {
      font-size: 14px;
    }
    & > p {
      color: var(--color-text-secondary);
    }
  }
`;

const P = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-primary);
`;

const StartsOn = ({ startsAt, endsAt, fromAboutDrawer }) => {
  if (!startsAt) return null;
  const startsAtDate = new Date(startsAt);
  const endsAtDate = endsAt ? new Date(endsAt) : null;
  const fromTo = endsAtDate && dateHelper.fromToDate(startsAtDate, endsAtDate);
  const startsOn = getDateShort(startsAtDate);
  const currentDate = new Date();
  let dateString = '';
  if (currentDate.getTime() < startsAtDate.getTime()) {
    dateString = `Starts on ${startsOn}`;
  } else if (currentDate.getTime() > startsAtDate.getTime() && !endsAtDate) {
    dateString = `Started on ${startsOn}`;
  } else if (
    currentDate.getTime() > startsAtDate.getTime() &&
    currentDate.getTime() < endsAtDate.getTime()
  ) {
    dateString = `Started on ${startsOn}`;
  } else {
    dateString = `Ended on ${getDateShort(endsAtDate)}`;
  }
  return (
    <Flex $fromAboutDrawer={fromAboutDrawer}>
      <IconWrapper>
        <CalendarFilled
          size={Spacings.SPACING_12B}
          color="var(--color-text-secondary)"
          viewBox="0 0 48 48"
        />
      </IconWrapper>
      <Info>
        <H6 color="var(--color-text-primary)">{dateString}</H6>
        <P>{fromTo}</P>
      </Info>
    </Flex>
  );
};

export default StartsOn;

StartsOn.propTypes = {
  startsAt: PropTypes.string,
  endsAt: PropTypes.string
};

StartsOn.defaultProps = {
  startsAt: null,
  endsAt: null
};
